//import {useWindowDimensions} from 'react-native';
import {isWebDesktopView} from '.';

export function useIsLandscape() {
  const isWebDesktop = isWebDesktopView();
  // const {height, width} = useWindowDimensions();
  // return width > height;

  return isWebDesktop ? true : false;
}
